import { GroupedFindings } from '@/api/model';
import { ML_SERVER } from '@/shared/constant';

export const extractMlServerFindings = (groupedData: GroupedFindings): GroupedFindings =>
  Object.fromEntries(
    Object.entries(groupedData)
      .map(([organ, mlFindings]) => [
        organ,
        mlFindings.filter((aiFinding) => aiFinding.renderedSummary.createdBy === ML_SERVER),
      ])
      .filter((mlFindings) => mlFindings.length > 0),
  );
